import {GridColumns, GridColDef, GridRowsProp, GridValueFormatterParams} from '@mui/x-data-grid-pro';

export const licenseeViewColumns: GridColDef[] = [
  // { field: 'licensee_id',
  //   type: 'number',
  //   headerName: 'ID',
  //   width: 80,
  //   hide: true,
  // },
  { field: 'company_name',
    type: 'string',
    headerName: 'Company Name',
    width: 200,
  },
  { field: 'officer_name',
    type: 'string',
    headerName: 'Officer Name ',
    width: 150,
  },
  { field: 'officer_title',
    type: 'string',
    headerName: 'Officer Title',
    width: 250,
  },
  { field: 'phone',
    type: 'string',
    headerName: 'Phone',
    width: 125,
  },
  { field: 'fax',
    type: 'string',
    headerName: 'Fax',
    width: 125,
  },
  { field: 'federal_tax_id',
    type: 'string',
    headerName: 'Tax ID',
    width: 100,
    hide: true,
  },
  { field: 'modify_datetime',
    type: 'dateTime',
    headerName: 'Last Modified',
    width: 175,
  },
];